import { ReactNode } from "react";
import { ExternalLinkV2 } from "../../link-v2";
import { buttonV2 } from "../../button-v2";
import { ExternalLinkIcon } from "../../../icons";

interface ExternalLinkProps {
  className?: string;
  children?: ReactNode;
  href: string;
}

/**
 * TODO: consider making this the new standard component
 */
export function ExternalLink({
  className,
  children = "Learn more",
  href,
}: ExternalLinkProps): JSX.Element {
  return (
    <ExternalLinkV2
      className={buttonV2({ variant: "action", className })}
      href={href}
    >
      <div>{children}</div>

      <ExternalLinkIcon className="w-4 h-4" />
    </ExternalLinkV2>
  );
}
